module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Light-c9e19122613db1d5a00589f0428858e5.woff";